import { Center, Spinner } from '@chakra-ui/react'

export function PageLoading() {
  return (
    <Center w="100%" h="100vh">
      <Spinner color="green.500" size="xl" />
    </Center>
  )
}
